import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import { forwardRef } from 'react';
import defaultStyles from './styles/Link.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { useLink } from '../../utils/link/hooks.js';
import { omit } from '../../utils/omit.js';

const Link = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    to,
    children,
    theme,
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const LinkComponent = useLink();
  if (LinkComponent) {
    return /*#__PURE__*/jsx(LinkComponent, {
      className: styles.link,
      ...omit(props, ['classNames', 'theme'])
    });
  }
  return /*#__PURE__*/jsx("a", {
    href: to,
    ref: ref,
    className: styles.link,
    ...omit(rest, ['classNames', 'theme']),
    children: children
  });
});

export { Link };
